import { Box, MenuItem, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import ApiService from "@/api/ApiService";
import { deviceIconCompany, deviceIcons, getDeviceIcon } from "../map/deviceIcons";

export function useRegionCompanies() {
  const { data = [] } = useQuery<{ id: number; externalId: string | null }[]>({
    queryKey: ["getRegions"],
    queryFn: ApiService.getEntities("region"),
  });
  return (region: number | null) => deviceIconCompany(data.find((item) => item.id === region)?.externalId);
}

export function DeviceIconPreview({ id, company }: { id: string | null; company: "jubau" | "dittgen" }) {
  const icon = getDeviceIcon(id, company);
  return icon ? <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
    <img src={icon.url} alt="" style={{ width: icon.size[0], height: icon.size[1], objectFit: "contain" }} />
    {icon.label}
  </Box> : <>{id || "Kein Icon"}</>;
}

export default function DeviceIconField({ value, disabled, region, onChange }: {
  value: string | null; disabled: boolean; region: number | null; onChange: (value: string | null) => void;
}) {
  const company = useRegionCompanies()(region);
  return <TextField select size="small" fullWidth disabled={disabled} value={value ?? ""}
    onChange={(event) => onChange(event.target.value || null)}>
    <MenuItem value="">Kein Icon</MenuItem>
    {value && !deviceIcons.some((icon) => icon.id === value) && <MenuItem value={value}>{value}</MenuItem>}
    {[...deviceIcons].sort((a, b) => a.label.localeCompare(b.label, "de")).map((icon) => <MenuItem value={icon.id} key={icon.id}>
      <DeviceIconPreview id={icon.id} company={company} />
    </MenuItem>)}
  </TextField>;
}
